module.exports = __webpack_public_path__ + "img/数据指标.89f84f46.svg";